export default "__VITE_PUBLIC_ASSET__0f51ed7c__"